import { Toast, ToastTitle, ToastBody } from "@fluentui/react-components";

// Define a function that accepts the dispatcher
export const showSuccessToast = (dispatchToast, message = "Operation successful!") => {
  dispatchToast(
    <Toast style={{
        color: 'black',
        borderLeft: '4px solid #549687',
        boxShadow: '0 1.6px 3.6px rgba(0,0,0,0.132), 0 0.3px 0.9px rgba(0,0,0,0.108)',
        borderRadius: '4px',
        backgroundColor: 'white',
      }}>
      <ToastTitle>{message}</ToastTitle>
    </Toast>,
    { timeout: 5000,
        intent: 'success'
     }
  );
};

export const showErrorToast = (dispatchToast, message = "Something went wrong") => {
  dispatchToast(
    <Toast style={{
        color: 'black',
        borderLeft: '4px solid #A4262C',
        boxShadow:
          '0 1.6px 3.6px rgba(0,0,0,0.132), 0 0.3px 0.9px rgba(0,0,0,0.108)',
        borderRadius: '4px',
        backgroundColor: 'white',
      }}>
      <ToastTitle style={{ fontWeight: 600 }}>Error</ToastTitle>
      <ToastBody>{message}</ToastBody>
    </Toast>,
    { timeout: 7000,
        intent: 'error'
     }
  );
};

export const TOASTER_ID = "timesheets-admin-toaster";